<template>
  <v-container
    v-if="avoidedResults && dollarsResults"
    fluid
    grid-list-md
    text-left
  >
    <v-tooltip right color="red darken-2">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          @click="onDisable"
          fab
          small
          color="red darken-2"
          dark
          class="up25"
        >
          <v-icon medium>keyboard_backspace</v-icon>
        </v-btn>
      </template>
      <span class="font-weight-bold body-2 white--text">
        Back to Configuration</span>
    </v-tooltip>

    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- internal supply summary *~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-layout row fill-height>
      <v-flex v-for="(item, index) in internalSupply" :key="index">
        <SimulateStat :title="item.title">
          <template slot="stat_img">
            <v-img
              :src="$parent.$options.methods.genImg(item.key, '_w')"
              class="mt-1"
              contain
            ></v-img>
          </template>
          <template slot="stat_data">
            <div class="text-right">
              <div class="text-right body-2">
                {{ item.name.toUpperCase() }}
              </div>
              <!-- <div class="text-right subheading">{{ item.title }}</div> -->
              <div class="text-right display-1 font-weight-bold compress">
                {{ item.value.toLocaleString() }}

                <span class="body-1">{{ item.unit }}</span>
              </div>
              <span class="text-right body-2"></span>
            </div>
          </template>
        </SimulateStat>
      </v-flex>
    </v-layout>

    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- external supply summary *~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-layout row mt-2>
      <v-flex xs12>
        <v-card color="blue-grey darken-5" class="pt-2 white--text">
          <v-layout row>
            <v-flex xs1>
              <v-img
                :src="$parent.$options.methods.genImg('external', '_w')"
                class="pt-5 mt-2"
                height="40px"
                contain
              ></v-img>
            </v-flex>

            <v-flex class="text-right mt-1">
              <div class="subheading">PEAK DEMAND</div>
              <div class="display-1 font-weight-bold compress">
                {{ externalSupply.peakDemandKw | formatInt }}
                <small>kW</small>
              </div>
            </v-flex>

            <v-flex class="text-right mt-1">
              <div class="subheading">ANNUAL USAGE</div>
              <div class="display-1 font-weight-bold compress">
                {{ externalSupply.annualUsageKw | formatInt }}
                <small>kW</small>
              </div>
            </v-flex>

            <v-flex class="text-right mt-1">
              <div class="subheading">LOAD FACTOR</div>
              <div class="display-1 font-weight-bold compress">
                {{ externalSupply.loadFactor | formatFloat }}
                <small>%</small>
              </div>
            </v-flex>

            <v-flex class="text-right mt-1 mr-3">
              <div class="subheading">COST / kWh</div>
              <div class="display-1 font-weight-bold compress">
                {{ parseFloat(externalSupply.costKwh).toFixed(6) }}
                <small></small>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- PIES !  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->

    <v-layout fill-height row mt-2>
      <!-- dollars  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <v-flex xs6>
        <CorePieChart v-model="series1" :series="series1" format="currency">
          <template slot="header">
            <h3 class="headline font-weight-bold">
              Annual Dollars
              <v-tooltip top color="#fa782e">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="#fa782e">info</v-icon>
                </template>                
                <span class="text-left font-weight-bold body-2 white--text">
                  Annual net revenue and savings from all grid-facing<br />value
                  streams (less variable costs like fuel)
                </span>
              </v-tooltip>
            </h3>
          </template>
          <template slot="footer">
            <v-divider></v-divider>
            <v-layout row mt-2>
              <v-flex xs4 text-xs-center>
                <div class="title grey--text">TOTAL</div>
                <div class="display-1 font-weight-bold compress">
                  {{ dollarsResults.total | bucks }}
                </div>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <div class="title grey--text">GOAL</div>
                <div class="display-1 font-weight-bold compress">
                  {{ dollarsResults.goal | bucks }}
                </div>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <div class="title grey--text">ACHIEVED</div>
                <div class="display-1 font-weight-bold compress">
                  {{ dollarsResults.achieved }}%
                </div>
              </v-flex>
            </v-layout>
          </template>
        </CorePieChart>
      </v-flex>

      <!-- avoided  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <v-flex xs6>
        <CorePieChart  v-model="series2" :series="series2" format="tons">
          <template slot="header">
            <h3 class="headline font-weight-bold">
              Annual Avoided Carbon
              <v-tooltip top color="#fa782e">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="#fa782e">info</v-icon>
                </template>                
                <span class="text-left font-weight-bold body-2 white--text">
                  Total net carbon emissions avoided by generating<br />power
                  onsite instead of taking power from the grid.</span>
              </v-tooltip>
            </h3>
          </template>
          <template slot="footer">
            <v-divider></v-divider>
            <v-layout row>
              <v-flex xs4 text-xs-center>
                <div class="title grey--text">TOTAL</div>
                <div class="display-1 font-weight-bold compress">
                  {{ avoidedResults.total | formatFloat }}
                  <span class="caption">Tons</span>
                </div>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <div class="title grey--text">GOAL</div>
                <div class="display-1 font-weight-bold compress">
                  {{ avoidedResults.goal | formatFloat }}
                  <span class="caption">Tons</span>
                </div>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <div class="title grey--text">ACHIEVED</div>
                <div class="display-1 font-weight-bold compress">
                  {{ avoidedResults.achieved }}%
                </div>
              </v-flex>
            </v-layout>
          </template>
        </CorePieChart>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SimulateStat from './SimulateStat'
export default {
  name: 'DollarsDashboard',
  components: {
    SimulateStat
  },
  watch: {
    dollarsResults() {
      this.genPies()
    },
    avoidedResults() {
      this.genPies()
    }
  },
  filters: {
    bucks(val) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(val)
    },
    formatInt(val) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(val)
    },
    formatFloat(val) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(val)
    }
  },
  created() {
    // console.log('SimulateDashboard dollarsResults', this.dollarsResults)
    // console.log('SimulateDashboard avoidedResults', this.avoidedResults)
    // console.log('SimulateDashboard internalSupply', this.internalSupply)
    // console.log('SimulateDashboard externalSupply', this.externalSupply)
    this.genPies()
  },
  props: {
    internalSupply: {
      type: Array,
      required: true
    },
    externalSupply: {
      type: Object,
      required: true
    },
    avoidedResults: {
      type: Object,
      required: true
    },
    dollarsResults: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      series1: false,
      series2: false
    }
  },
  methods: {
    onDisable() {
      this.$parent.dashboardOpen = false // methods.toggleDashboard()
      //   this.$parent.$options.methods.toggleDashboard()
      //   this.$parent.$emit('toggleDashboard')
    },
    genPies() {
      // console.log('genPies()')
      // console.log('  avoided', this.avoidedResults)
      // console.log('  dollars', this.dollarsResults)
      let dollars = [
        {
          name: 'Demand Response',
          y: this.dollarsResults.demandResponse,
          selected: true,
          sliced: true
        },
        {
          name: 'Energy Sales',
          y: this.dollarsResults.energySales,
          selected: false,
          sliced: true
        },
        {
          name: 'Demand Savings',
          y: this.dollarsResults.demandSavings,
          selected: false,
          sliced: true
        },
        {
          name: 'Capacity Sales',
          y: this.dollarsResults.capacity,
          selected: false,
          sliced: true
        }
      ]

      let avoided = [
        {
          name: 'Solar',
          y: this.avoidedResults.solar,
          selected: true,
          sliced: true
        },
        {
          name: 'Curtailment',
          y: this.avoidedResults.curtailment,
          selected: false,
          sliced: true
        },
        {
          name: 'Generation',
          y: this.avoidedResults.generation,
          selected: false,
          sliced: true
        }
      ]
      this.series1 = [
        {
          name: 'Annual Dollars',
          colorByPoint: true,
          allowPointSelect: true,
          data: dollars
        }        
      ]
      // console.log("series1", this.series1)

      this.series2 = [
        {
          name: 'Annual Avoided Carbon',
          colorByPoint: true,
          allowPointSelect: true,
          data: avoided
        }
      ]
      // console.log("series2", this.series2)
    }
  }
} // export
</script>
